import React, { useEffect, useRef, useState } from "react";
import { ProgrammingLanguage } from "../../../../Interface/Index";
import codeService from "../../../../Services/code.service";
import AiAssessmentCodeEditor from "./AiAssessmentCodeEditor";
import { useAIAssessmentContext } from "../../../../Context/AIAssessmentContext/AIAssessmentContext";

interface AiAssessmentCodingRoundProps {
  handleCodingFullscreenToggle: () => void;
  isCodingFullscreen: boolean;
}
const AiAssessmentCodingRound: React.FC<AiAssessmentCodingRoundProps> = ({
  handleCodingFullscreenToggle,
  isCodingFullscreen,
}) => {
  const { currentStep, aiAssessmentQuestions } = useAIAssessmentContext();
  const question = aiAssessmentQuestions[currentStep];

  const [languages, setLanguages] = useState<ProgrammingLanguage[]>([]);
  const [output, setOutput] = useState<string | null>(null);
  const [isCompiling, setCompiling] = useState({
    loading: false,
    message: "",
  });

  const prevQuestionIdRef = useRef<string | null>(null);

  const getLanguages = async () => {
    const languageResponse = await codeService.getAllLanguages();
    setLanguages(languageResponse);
  };

  useEffect(() => {
    const init = async () => {
      try {
        setCompiling({ loading: true, message: "Loading editor..." });
        await getLanguages();
      } catch (error: any) {
        console.log("🚀 ~ init code editor ~ error:", error);
      } finally {
        setCompiling({ loading: false, message: "" });
      }
    };

    init();
  }, []);

  useEffect(() => {
    if (question && question.questionId !== prevQuestionIdRef.current) {
      prevQuestionIdRef.current = question.questionId;
      setOutput(null); // Clear output when question changes
      const syntheticEvent = {
        target: { value: "" },
      } as React.ChangeEvent<HTMLTextAreaElement>;
      // onChange(syntheticEvent, null);
    }
  }, [question]);

  // Reset output when question changes
  useEffect(() => {
    if (question) {
      setOutput(null);
    }
  }, [question]);

  return (
    <div className="ai-assessment-coding-round">
      <AiAssessmentCodeEditor
        languages={languages}
        setCompiling={setCompiling}
        handleCodingFullscreenToggle={handleCodingFullscreenToggle}
        output={output}
        setOutput={setOutput}
        isCodingFullscreen={isCodingFullscreen}
        isCompiling={isCompiling}
      />
    </div>
  );
};

export default AiAssessmentCodingRound;
